import React from 'react';
import { Button } from '@benzinga/core-ui';

export const PricePredictionButton: React.FC<{ btn_link: string; btn_label: string }> = ({ btn_label, btn_link }) => {
  return (
    <Button as="a" className="w-full mt-3" href={btn_link} size="md" variant="flat-blue">
      {btn_label}
    </Button>
  );
};
